import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { initI18n } from './translations/i18n';
import { StoreProvider } from './store';
import { Layout } from './components/layout/layout';
import { Wizard } from './components/wizard/wizard';
import { SuccessPage } from './components/success-page/success-page';
import { ErrorFieldProvider } from './components/common/error-field-context';
import { NotFoundPage } from './components/not-found-page/not-found-page';
import { QuotePreview } from './components/quote-preview/quote-preview';

const MultiRoute = (el: React.JSX.Element, ...paths: string[]) => {
  return paths.map(p => <Route key={p} path={p} element={el} />);
};

function App() {
  initI18n();

  return (
    <StoreProvider>
      <ErrorFieldProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              {MultiRoute(<Wizard />, '/signup', '/signup.aspx')}
              {MultiRoute(<SuccessPage />, '/success', '/signupsuccess.aspx')}
              <Route path="*" element={<NotFoundPage />} />
              <Route path="/QuotePreview.aspx" element={<QuotePreview />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </ErrorFieldProvider>
    </StoreProvider>
  );
}

export default App;
